// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-quartz {
  --ag-header-background-color: #3B71CA;
}

::ng-deep .custom-table .ag-header-cell-text {
  color: rgb(255, 255, 255) !important;
}

::ng-deep .custom-table .ag-row {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/features/insight-egrc/shared/table/insight-egrc-table.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".ag-theme-quartz {\n  --ag-header-background-color: #3B71CA;\n}\n\n::ng-deep .custom-table .ag-header-cell-text {\n  color: rgb(255, 255, 255) !important;\n}\n\n::ng-deep .custom-table .ag-row {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
